<div class="calendar-empty-header"></div>
